import { gql } from "@apollo/client";

const addProofToOrderProductionJobMutation = gql`
  mutation ($orderProductionJobId: ID!, $fileIdentifier: String!, $force: Boolean) {
    addProofToOrderProductionJob(
      orderProductionJobId: $orderProductionJobId
      fileIdentifier: $fileIdentifier
      force: $force
    ) {
      errors {
        orderProductionJobId
        fileIdentifier
      }
      updatedOrderProductionJob {
        id
      }
      succeeded
    }
  }
`;

export default addProofToOrderProductionJobMutation;
